import React from "react";
import { ReactFlowStateContextActions } from "../ReactFlowStateContextActions";

export function useReactFlowActions() {
  return React.useContext(ReactFlowStateContextActions);
}
